<template>
  <page-outline :title="$t('common.security.ssh')">
    <template slot="pageContent">
      <div slot="pageContent">
        <b-container fluid>
          <b-row class="justify-content-start mb-5">
            <b-col cols="4" sm="3" md="2" xl="1">
              <back-button :returnUrl="returnUrl"></back-button>
            </b-col>
          </b-row>
          <div>
            <form-accordion :title="$t('common.security.ssh')" :isTitleUpperCase="false" >
              <b-row class="d-flex justify-content-start align-items-center">
                <b-col sm="6" v-if="isRightPod" class="form-group">
                  <div>
                    <span class="filter-item-title">{{ $t('common.security.pod_select') }}</span>
                    <span class="color-red">* </span>
                    <b-form-select v-model="form.pod" :options="podList" style="font-size:small;"></b-form-select>
                  </div>
                </b-col>
                <b-col sm="6" class="form-group">
                  <form-write-group-label-input v-model="form.name" isMandatory
                    :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('common.security.public_key')" :isTitleUpperCase="false">
              <div v-if="this.id != -1">
                <button class="btn w-auto px-4 btn-tertiary mb-5" v-if="form.statePublicKey == 1" @click="updatePublicKey">{{ $t('common.security.update_public_key') }}</button>
                <button class="btn w-auto px-4 btn-tertiary mb-5" v-else @click="cancelPublicKey">{{ $t('common.security.cancel_public_key') }}</button>
              </div>
              <b-row v-if="publicKeyText === '' && form.statePublicKey === 0" class="d-flex justify-content-start align-items-center">
                <b-col sm="6" class="form-group">
                  <span class="filter-item-title">{{ $t('common.security.public_key_file') }}</span>
                  <span class="color-red">* </span>
                  <b-form-textarea
                    style="max-height: none;"
                    id="textarea"
                    v-model="publicKeyText"
                    @input="processPublicKey"
                    :placeholder="$t('common.enter_something')"
                    rows="6">
                  </b-form-textarea>
                </b-col>
                <b-col sm="6" class="form-group d-flex flex-column" v-if="publicKeyText === ''" >
              <span>
                <span class="filter-item-title">{{ $t('common.security.public_key_file') }}</span>
                <span class="color-red">* </span>
              </span>
                  <input type="file" @change="handleFileUploadPublicKey"/>
                </b-col>
              </b-row>
              <b-row v-if="publicKeyText != ''" class="d-flex justify-content-start align-items-center">
                <b-col sm="12" class="form-group">
                  <span class="filter-item-title">{{ $t('common.security.public_key_file') }}</span>
                  <span class="color-red">* </span>
                  <b-form-textarea
                    style="max-height: none;"
                    id="textarea"
                    v-model="publicKeyText"
                    @input="processPublicKey"
                    :placeholder="$t('common.enter_something')"
                    rows="6">
                  </b-form-textarea>
                </b-col>
                <b-col sm="6" class="form-group d-flex flex-column" v-if="publicKeyText === ''" >
              <span>
                <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
                <span class="color-red">* </span>
              </span>
                  <input type="file" @change="handleFileUploadPublicKey" />
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('common.security.private_key')" :isTitleUpperCase="false">
              <div v-if="this.id !== -1">
                <button class="btn w-auto px-4 btn-tertiary mb-5" v-if="form.statePrivateKey == 1" @click="updatePrivateKey">{{ $t('common.security.update_privatekey') }}</button>
                <button class="btn w-auto px-4 btn-tertiary mb-5" v-else @click="cancelPrivateKey">{{ $t('common.security.cancel_privatekey') }}</button>
              </div>
              <b-row class="d-flex justify-content-start align-items-center">
                <b-col v-if="privateKeyText === '' && form.statePrivateKey === 0" sm="6" class="form-group">
                  <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
                  <span class="color-red">* </span>
                  <b-form-textarea
                    style="max-height: none;"
                    id="textarea"
                    v-model="privateKeyText"
                    @input="processPrivateKey"
                    :placeholder="$t('common.enter_something')"
                    rows="6">
                  </b-form-textarea>
                </b-col>
                <b-col v-if="privateKeyText !== '' && form.statePrivateKey === 0" sm="12" class="form-group">
                  <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
                  <span class="color-red">* </span>
                  <b-form-textarea
                    style="max-height: none;"
                    id="textarea"
                    v-model="privateKeyText"
                    @input="processPrivateKey"
                    :placeholder="$t('common.enter_something')"
                    rows="6">
                  </b-form-textarea>
                </b-col>
                <b-col sm="6" class="form-group d-flex flex-column" v-if="privateKeyText === '' && form.statePrivateKey === 0" >
                  <span>
                    <span class="filter-item-title">{{ $t('common.security.private_key_file') }}</span>
                    <span class="color-red">* </span>
                  </span>
                  <input type="file" @change="handleFileUploadPrivateKey" />
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6" class="form-group">
                  <form-write-group-label-input v-model="form.password" isMandatory
                    :inputLabel="$t('common.security.password')" :placeholderValue="$t('common.security.password')">
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="6" class="form-group"></b-col>
              </b-row>
            </form-accordion>
          </div>
          <b-row v-if="this.id === -1" class="accordionForm mt-3 justify-content-end">
            <b-col cols="4" lg="2" xl="1" v-if="form.pod !== '' && form.name !== '' && privateKeyText !== '' && publicKeyText !== ''">
              <b-button variant="primary"
                @click="createSSH()">
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.sve') }}</span>
              </b-button>
            </b-col>
            <b-col cols="4" lg="2" xl="1" v-else>
              <b-button variant="primary" disabled>
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.sve') }}</span>
              </b-button>
            </b-col>


          </b-row>
          <b-row v-else class="accordionForm mt-3 justify-content-end">
            <b-col cols="4" lg="2" xl="1" v-if="form.pod !== '' && form.name !== '' && (form.statePrivateKey === 1 || (form.statePrivateKey === 0 && privateKeyText !== '')) && (form.statePublicKey === 1 || (form.statePublicKey === 0 && publicKeyText !== ''))">
              <b-button variant="primary"
                @click="updateSSH()">
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.sve') }}</span>
              </b-button>
            </b-col>
            <b-col cols="4" lg="2" xl="1" v-else>
              <b-button variant="primary" disabled>
                <i class="fa-light fa-save"></i>
                <span>{{ $t('common.sve') }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import forge from 'node-forge';
import SecurityPopUp from "@/popups/security/SecurityPopUp.vue";
import _ from "lodash";
import {loadPage} from "@/helpers/routing";

export default {
  name: 'SecuritySSHForm',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'security-pop-up': SecurityPopUp
  },
  props: ['id'],
  data () {
    return {
      form: {
        statePrivateKey: 0,
        statePublicKey: 0,
        privateKey: '',
        publicKey: '',
        name: '',
        password: '',
        id: '',
        pod: ''
      },
      publicKeyText: '',
      privateKeyText: '',
      certificateInfo: null,
      active: '0',
      filteredNorms: [],
      hrtpNorm: false,
      login: '',
      name: '',
      password: '',
      passwordType: 'password',
      profiles: [],
      srtpNorm: false,
      showModalElement: false,
      id_rights_profile: '',
      caList: [],
      caListPopUp: [],
      podList: [],
      canSaveTrustStore: false
    }
  },
  created () {
    let that = this
    this.$engine.routing.pod.fetch()
    .then(resp => {
      if (resp.data.Pods.length > 0){
        this.podList.push({text: this.$i18n.t('common.security.select_an_option'), value: ''})
        resp.data.Pods.forEach(element => {
          this.podList.push({text: element.name, value: element.name})
        })
      }

    })
    .catch(error => {
      errorMessageAlert(error, that)
    })
  },
  watch: {
    form: {
      handler() {
      },
      deep: true,
    },
  },
  methods: {
    isRightPod () {
      return this.$engine.rights.rightIs('pod_consult', true)
    },
    updatePrivateKey () {
      this.form.statePrivateKey = 0
      this.form = _.cloneDeep(this.form)
    },
    cancelPrivateKey () {
      this.form.statePrivateKey = 1
      this.privateKeyText = ''
      this.form.startDate = this.oldStartDate
      this.form.endDate = this.oldEndDate
      this.form = _.cloneDeep(this.form)
    },
    updatePublicKey () {
      this.form.statePublicKey = 0
      this.form = _.cloneDeep(this.form)
    },
    cancelPublicKey () {
      this.form.statePublicKey = 1
      this.certificateText = ''
      this.form.startDate = this.oldStartDate
      this.form.endDate = this.oldEndDate
      this.form = _.cloneDeep(this.form)
    },
    processPublicKey () {
      // try {
      //   // Vérifier si la clé publique est en format OpenSSH (commence par "ssh-rsa")
      //   if (this.publicKeyText.startsWith('---- BEGIN SSH2 PUBLIC KEY ----')) {
      //     this.form.publicKey = this.publicKeyText;  // Simplement afficher ou utiliser la clé telle quelle
      //   } else {
      //     throw new Error('Format de clé publique SSH non valide.');
      //   }
      // } catch (err) {
      //   this.errorMessage = 'Erreur lors du traitement de la clé publique SSH';
      //   console.error(err);
      //   this.publicKeyText = ''
      // }
    },
    processPrivateKey () {
      // try {
      //   // Valider que c'est bien une clé privée SSH en vérifiant le format
      //   if (this.privateKeyText.startsWith('-----BEGIN OPENSSH PRIVATE KEY-----')) {
      //     this.form.privateKey = this.privateKeyText;  // Simplement afficher ou utiliser la clé telle quelle
      //   } else {
      //     throw new Error('Format de clé privée SSH non valide.');
      //   }
      // } catch (err) {
      //   this.errorMessage = 'Erreur lors du traitement de la clé privée SSH';
      //   console.error(err);
      //   this.privateKeyText = ''
      // }
    },
    handleFileUploadPrivateKey(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        this.form.privateKey = e.target.result
        this.privateKeyText = e.target.result
      };

      reader.readAsText(file)
    },
    handleFileUploadPublicKey(event, index = null) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        this.form.publicKey = e.target.result
        this.publicKeyText = e.target.result
      };

      reader.readAsText(file)
    },
    formHasError() {
      // let that = this
      // let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      // if (this.login === undefined || this.login === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_login'))
      //   return true
      // }
      // if (this.name === undefined || this.name === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_name'))
      //   return true
      // }
      // if (this.password === undefined || this.password === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_password'))
      //   return true
      // }
      // if (this.password && !regexPassword.test(this.password)) {
      //   this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
      //   return true
      // }
      // if (!this.realProfileList.filter(status => status.state === 1
      //     && ((that.hrtpNorm && status.label.includes('_HRTP'))
      //         || (that.srtpNorm && status.label.includes('_SRTP'))
      //         || (!status.label.includes('_HRTP') && !status.label.includes('_SRTP')))).length) {
      //   this.okMessageBox(this.$t('usercompany.missing_profile'))
      //   return true
      // }
      // return false
    },
    createSSH (){
      let that = this
      /*if (this.form.password == '') {
        this.$f7.alert(that.$i18n.t('common.security.missing_ssh_password'), 'Error')
      } else*/ if (this.isRightPod) {
        if (this.form.pod == ''){
          this.$f7.alert(that.$i18n.t('common.security.missing_ssh_pod'), 'Error')
        }
      } else if (this.form.name == '') {
        this.$f7.alert(that.$i18n.t('common.security.missing_ssh_name'), 'Error')
      } else if (this.form.privateKey == '' && this.form.statePrivateKey == 0) {
        this.$f7.alert(that.$i18n.t('common.security.missing_ssh_private_key'), 'Error')
      } else if (this.form.publicKey == '' && this.form.statePublicKey == 0) {
        this.$f7.alert(that.$i18n.t('common.security.missing_ssh_public_key'), 'Error')
      }
      if (this.form.password != '' || this.form.pod != '' || this.form.name != '' || this.form.privateKey != '' || this.form.publicKey != '') {
        let form = {
          name: this.form.name,
          password: this.form.password,
          idPod: this.form.pod,
          privateKey: this.form.privateKey,
          publicKey: this.form.publicKey
        }

        let that = this

        if (this.formHasError()) {
          return
        }

        this.$engine.security.ssh.create(form)
        .then(resp => {
          that.$f7.alert(that.$i18n.t('common.security.create_ssh'), 'Create SSH')
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }

    },
  }
}
</script>